import { SelectMenu } from 'src/components/SelectMenu';
import {
  ATTRIBUTE_SELECT_MENU_PROPS,
  ATTRIBUTE_SELECT_TRIGGER_PROPS,
  useAttributeCommit,
  useAttributeMenuOptions,
} from 'src/graphql/entities/custom-attributes/field-view-registry/components/attribute-select-menu';
import { CustomAttributeEditProps } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';

export const DropdownEditor = ({
  value,
  definition: { options, label },
  onChange,
  onSave,
  disabled,
  saving,
}: CustomAttributeEditProps) => {
  const selected = getKindLikeValueSafely(value, 'dropdown');
  const menuOptions = useAttributeMenuOptions(options);
  const commit = useAttributeCommit({ onChange, onSave });

  return (
    <SelectMenu
      {...ATTRIBUTE_SELECT_MENU_PROPS}
      {...ATTRIBUTE_SELECT_TRIGGER_PROPS}
      label={label}
      options={menuOptions}
      value={selected}
      onChange={(next) => commit({ kind: 'dropdown', value: next })}
      onClear={() => commit({ kind: 'dropdown', value: null })}
      triggerLoading={saving}
      disabled={disabled}
      placeholder="Empty"
    />
  );
};
